import type { Program, ProgramActivityContentObjectList } from 'models';
import { can } from 'old/utils/permissions';
import type { PeriodicityType } from 'models/activity';
import { ActivityTask } from '../../../feed';

type P = {
  item: ProgramActivityContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ActivityContent = ({ item, program }: P) => {
  const activity = {
    ...item.activity,
    description: item.activity.description ?? '',
    htmlDescription: item.activity.htmlDescription ?? '',
    nextPeriodDate: item.activity.nextPeriodDate ?? null,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- Backend documents periodicity_type as a plain string; ActivityTask needs the narrower literal union
    periodicityType: item.activity.periodicityType as PeriodicityType,
    programsTopicId: item.programsTopic.id,
    times: item.activity.times ?? [],
  };

  return (
    <div className="topic-item__activity">
      <div className="topic-item__activity-tasks">
        <ActivityTask
          activity={activity}
          canDownloadReport={Boolean(can(program, 'Program', 'downloadReport'))}
          canSubmitData={Boolean(can(activity, 'Activity', 'submitData'))}
          isProgramPublished={program.status === 'published'}
          // eslint-disable-next-line @typescript-eslint/require-await -- ActivityTask's onSuccess prop requires an async function
          onSuccess={async () => undefined}
          reloadingPost={false}
          userSubscribed={Boolean(can(item.program, 'Program', 'joinedAsUser'))}
        />
      </div>
    </div>
  );
};

export default ActivityContent;
